
var HebcaMiddlewareX = HebcaMiddlewareX || {};
(function($mx) {

    //将函数转化为Promise
    function toPromise(func,param){
        return new Promise(function (resolve,reject) {
            if(!param){
                param={}
            }
            param.success=function (ret) {
                resolve(ret);
            };
            param.fail=function (msg) {
                reject(new Error(msg));
            };
            func(param);
        });
    }

    function toPromiseWithObj(obj,func,param){
        return new Promise(function (resolve,reject) {
            if(!param){
                param={}
            }
            param.success=function (ret) {
                resolve(ret);
            };
            param.fail=function (msg) {
                reject(new Error(msg));
            };
            func.call(obj,param);
        });
    }

    //中间件包装类
    function MiddlewareWapper(obj){
        this.obj=obj;
    }
    MiddlewareWapper.prototype.reload=function(param){
        return toPromiseWithObj(this.obj,this.obj.reload,param);
    };
    MiddlewareWapper.prototype.reset=function(param){
        return toPromiseWithObj(this.obj,this.obj.reset,param);
    };
    MiddlewareWapper.prototype.getCerts=function(param){
        return toPromiseWithObj(this.obj,this.obj.getCerts,param);
    };
    MiddlewareWapper.prototype.getCertInfo=function(param){
        return toPromiseWithObj(this.obj,this.obj.getCertInfo,param);
    };
    MiddlewareWapper.prototype.selectCert=function(param){
        return toPromiseWithObj(this.obj,this.obj.selectCert,param);
    };
    MiddlewareWapper.prototype.sign=function(param){
        return toPromiseWithObj(this.obj,this.obj.sign,param);
    };
    MiddlewareWapper.prototype.signBatch=function(param){
        return toPromiseWithObj(this.obj,this.obj.signBatch,param);
    };
    MiddlewareWapper.prototype.login=function(param){
        return toPromiseWithObj(this.obj,this.obj.login,param);
    };
    MiddlewareWapper.prototype.logout=function(param){
        return toPromiseWithObj(this.obj,this.obj.logout,param);
    };
    MiddlewareWapper.prototype.verifySign=function(param){
        return toPromiseWithObj(this.obj,this.obj.verifySign,param);
    };
    MiddlewareWapper.prototype.verifySignBatch=function(param){
        return toPromiseWithObj(this.obj,this.obj.verifySignBatch,param);
    };
    MiddlewareWapper.prototype.certEncrypt=function(param){
        return toPromiseWithObj(this.obj,this.obj.certEncrypt,param);
    };
    MiddlewareWapper.prototype.certDecrypt=function(param){
        return toPromiseWithObj(this.obj,this.obj.certDecrypt,param);
    };
    MiddlewareWapper.prototype.genAndWrapperKey=function(param){
        return toPromiseWithObj(this.obj,this.obj.genAndWrapperKey,param);
    };
    MiddlewareWapper.prototype.genKey=function(param){
        return toPromiseWithObj(this.obj,this.obj.genKey,param);
    };
    MiddlewareWapper.prototype.importWrapperKey=function(param){
        return toPromiseWithObj(this.obj,this.obj.importWrapperKey,param);
    };
    MiddlewareWapper.prototype.encrypt=function(param){
        return toPromiseWithObj(this.obj,this.obj.encrypt,param);
    };
    MiddlewareWapper.prototype.encryptStep=function(param){
        return toPromiseWithObj(this.obj,this.obj.encryptStep,param);
    };
    MiddlewareWapper.prototype.decrypt=function(param){
        return toPromiseWithObj(this.obj,this.obj.decrypt,param);
    };
    MiddlewareWapper.prototype.decryptStep=function(param){
        return toPromiseWithObj(this.obj,this.obj.decryptStep,param);
    };
    MiddlewareWapper.prototype.encryptFile=function(param){
        return toPromiseWithObj(this.obj,this.obj.encryptFile,param);
    };
    MiddlewareWapper.prototype.decryptFile=function(param){
        return toPromiseWithObj(this.obj,this.obj.decryptFile,param);
    };
    MiddlewareWapper.prototype.closeKey=function(param){
        return toPromiseWithObj(this.obj,this.obj.closeKey,param);
    };
    MiddlewareWapper.prototype.getDevices=function(param){
        return toPromiseWithObj(this.obj,this.obj.getDevices,param);
    };
    MiddlewareWapper.prototype.selectDevice=function(param){
        return toPromiseWithObj(this.obj,this.obj.selectDevice,param);
    };
    MiddlewareWapper.prototype.getDeviceInfo=function(param){
        return toPromiseWithObj(this.obj,this.obj.getDeviceInfo,param);
    };
    MiddlewareWapper.prototype.getRandom=function(param){
        return toPromiseWithObj(this.obj,this.obj.getRandom,param);
    };
    MiddlewareWapper.prototype.getDatas=function(param){
        return toPromiseWithObj(this.obj,this.obj.getDatas,param);
    };
    MiddlewareWapper.prototype.readData=function(param){
        return toPromiseWithObj(this.obj,this.obj.readData,param);
    };
    MiddlewareWapper.prototype.writeData=function(param){
        return toPromiseWithObj(this.obj,this.obj.writeData,param);
    };
    MiddlewareWapper.prototype.deleteData=function(param){
        return toPromiseWithObj(this.obj,this.obj.deleteData,param);
    };
    MiddlewareWapper.prototype.digest=function(param){
        return toPromiseWithObj(this.obj,this.obj.digest,param);
    };
    MiddlewareWapper.prototype.digestFile=function(param){
        return toPromiseWithObj(this.obj,this.obj.digestFile,param);
    };
    MiddlewareWapper.prototype.encryptSoft=function(param){
        return toPromiseWithObj(this.obj,this.obj.encryptSoft,param);
    };
    MiddlewareWapper.prototype.encryptSoftFile=function(param){
        return toPromiseWithObj(this.obj,this.obj.encryptSoftFile,param);
    };
    MiddlewareWapper.prototype.decryptSoft=function(param){
        return toPromiseWithObj(this.obj,this.obj.decryptSoft,param);
    };
    MiddlewareWapper.prototype.decryptSoftFile=function(param){
        return toPromiseWithObj(this.obj,this.obj.decryptSoftFile,param);
    };
    MiddlewareWapper.prototype.signMessage=function(param){
        return toPromiseWithObj(this.obj,this.obj.signMessage,param);
    };
    MiddlewareWapper.prototype.signMessageBatch=function(param){
        return toPromiseWithObj(this.obj,this.obj.signMessageBatch,param);
    };
    MiddlewareWapper.prototype.verifyMessageBatch=function(param){
        return toPromiseWithObj(this.obj,this.obj.verifyMessageBatch,param);
    };
    MiddlewareWapper.prototype.verifyMessage=function(param){
        return toPromiseWithObj(this.obj,this.obj.verifyMessage,param);
    };
    MiddlewareWapper.prototype.envelopeMessage=function(param){
        return toPromiseWithObj(this.obj,this.obj.envelopeMessage,param);
    };
    MiddlewareWapper.prototype.envelopeMessageFile=function(param){
        return toPromiseWithObj(this.obj,this.obj.envelopeMessageFile,param);
    };
    MiddlewareWapper.prototype.envelopeMessageBigFile=function(param){
        return toPromiseWithObj(this.obj,this.obj.envelopeMessageBigFile,param);
    };
    MiddlewareWapper.prototype.unenvelopeMessage=function(param){
        return toPromiseWithObj(this.obj,this.obj.unenvelopeMessage,param);
    };
    MiddlewareWapper.prototype.unenvelopeMessageFile=function(param){
        return toPromiseWithObj(this.obj,this.obj.unenvelopeMessageFile,param);
    };
    MiddlewareWapper.prototype.unenvelopeMessageBigFile=function(param){
        return toPromiseWithObj(this.obj,this.obj.unenvelopeMessageBigFile,param);
    };
    MiddlewareWapper.prototype.loginDevice=function(param){
        return toPromiseWithObj(this.obj,this.obj.loginDevice,param);
    };
    MiddlewareWapper.prototype.logoutDevice=function(param){
        return toPromiseWithObj(this.obj,this.obj.logoutDevice,param);
    };
    MiddlewareWapper.prototype.changePassword=function(param){
        return toPromiseWithObj(this.obj,this.obj.changePassword,param);
    };
    MiddlewareWapper.prototype.genKeyPair=function(param){
        return toPromiseWithObj(this.obj,this.obj.genKeyPair,param);
    };
    MiddlewareWapper.prototype.importKeyPair=function(param){
        return toPromiseWithObj(this.obj,this.obj.importKeyPair,param);
    };
    MiddlewareWapper.prototype.importCert=function(param){
        return toPromiseWithObj(this.obj,this.obj.importCert,param);
    };
    MiddlewareWapper.prototype.addEventListener=function(param){
        return this.obj.addEventListener(param);
    };
    MiddlewareWapper.prototype.removeEventListener=function(param){
        return this.obj.removeEventListener(param);
    };
    MiddlewareWapper.prototype.fireEvent=function(param){
        return toPromiseWithObj(this.obj,this.obj.fireEvent,param);
    };
    MiddlewareWapper.prototype.agreementBegin=function(param){
        return toPromiseWithObj(this.obj,this.obj.agreementBegin,param);
    };
    MiddlewareWapper.prototype.agreementResponse=function(param){
        return toPromiseWithObj(this.obj,this.obj.agreementResponse,param);
    };
    MiddlewareWapper.prototype.agreementEnd=function(param){
        return toPromiseWithObj(this.obj,this.obj.agreementEnd,param);
    };
    MiddlewareWapper.prototype.readFile=function(param){
        return toPromiseWithObj(this.obj,this.obj.readFile,param);
    };
    MiddlewareWapper.prototype.writeFile=function(param){
        return toPromiseWithObj(this.obj,this.obj.writeFile,param);
    };
    MiddlewareWapper.prototype.downloadFile=function(param){
        return toPromiseWithObj(this.obj,this.obj.downloadFile,param);
    };
    MiddlewareWapper.prototype.uploadFile=function(param){
        return toPromiseWithObj(this.obj,this.obj.uploadFile,param);
    };
    MiddlewareWapper.prototype.signTimeStamp=function(param){
        return toPromiseWithObj(this.obj,this.obj.signTimeStamp,param);
    };
    MiddlewareWapper.prototype.signTimeStampBatch=function(param){
        return toPromiseWithObj(this.obj,this.obj.signTimeStampBatch,param);
    };
    MiddlewareWapper.prototype.verifyTimeStamp=function(param){
        return toPromiseWithObj(this.obj,this.obj.verifyTimeStamp,param);
    };
    MiddlewareWapper.prototype.verifyTimeStampBatch=function(param){
        return toPromiseWithObj(this.obj,this.obj.verifyTimeStampBatch,param);
    };
    MiddlewareWapper.prototype.getTimeStampInfo=function(param){
        return toPromiseWithObj(this.obj,this.obj.getTimeStampInfo,param);
    };
    MiddlewareWapper.prototype.authBegin=function(param){
        return toPromiseWithObj(this.obj,this.obj.authBegin,param);
    };
    MiddlewareWapper.prototype.format=function(param){
        return toPromiseWithObj(this.obj,this.obj.format,param);
    };
    MiddlewareWapper.prototype.unlock=function(param){
        return toPromiseWithObj(this.obj,this.obj.unlock,param);
    };
    MiddlewareWapper.prototype.epsImportSymmKey=function(param){
        return toPromiseWithObj(this.obj,this.obj.epsImportSymmKey,param);
    };
    MiddlewareWapper.prototype.epsWriteESealData=function(param){
        return toPromiseWithObj(this.obj,this.obj.epsWriteESealData,param);
    };
    MiddlewareWapper.prototype.epsReadESealData=function(param){
        return toPromiseWithObj(this.obj,this.obj.epsReadESealData,param);
    };
    MiddlewareWapper.prototype.epsEncrypt=function(param){
        return toPromiseWithObj(this.obj,this.obj.epsEncrypt,param);
    };
    MiddlewareWapper.prototype.epsDecrypt=function(param){
        return toPromiseWithObj(this.obj,this.obj.epsDecrypt,param);
    };
    MiddlewareWapper.prototype.epsMac=function(param){
        return toPromiseWithObj(this.obj,this.obj.epsMac,param);
    };
    MiddlewareWapper.prototype.showFileDialog=function(param){
        return toPromiseWithObj(this.obj,this.obj.showFileDialog,param);
    };
    MiddlewareWapper.prototype.getFileInfo=function(param){
        return toPromiseWithObj(this.obj,this.obj.getFileInfo,param);
    };
    MiddlewareWapper.prototype.getFilePath=function(param){
        return toPromiseWithObj(this.obj,this.obj.getFilePath,param);
    };
    MiddlewareWapper.prototype.removeFile=function(param){
        return toPromiseWithObj(this.obj,this.obj.removeFile,param);
    };
    MiddlewareWapper.prototype.extSign=function(param){
        return toPromiseWithObj(this.obj,this.obj.extSign,param);
    };
    MiddlewareWapper.prototype.extVerify=function(param){
        return toPromiseWithObj(this.obj,this.obj.extVerify,param);
    };
    MiddlewareWapper.prototype.extEncrypt=function(param){
        return toPromiseWithObj(this.obj,this.obj.extEncrypt,param);
    };
    MiddlewareWapper.prototype.extDecrypt=function(param){
        return toPromiseWithObj(this.obj,this.obj.extDecrypt,param);
    };
    MiddlewareWapper.prototype.extGenKeyPair=function(param){
        return toPromiseWithObj(this.obj,this.obj.extGenKeyPair,param);
    };
    MiddlewareWapper.prototype.verifyCert=function(param){
        return toPromiseWithObj(this.obj,this.obj.verifyCert,param);
    };
    MiddlewareWapper.prototype.verifyCertAtTime=function(param){
        return toPromiseWithObj(this.obj,this.obj.verifyCertAtTime,param);
    };
    MiddlewareWapper.prototype.verifyCertSign=function(param){
        return toPromiseWithObj(this.obj,this.obj.verifyCertSign,param);
    };
    MiddlewareWapper.prototype.setContext=function(param){
        return toPromiseWithObj(this.obj,this.obj.setContext,param);
    };
    MiddlewareWapper.prototype.saveEvidence=function(param){
        return toPromiseWithObj(this.obj,this.obj.saveEvidence,param);
    };
    MiddlewareWapper.prototype.readEvidence=function(param){
        return toPromiseWithObj(this.obj,this.obj.readEvidence,param);
    };
    MiddlewareWapper.prototype.zxq1Enroll=function(param){
        return toPromiseWithObj(this.obj,this.obj.zxq1Enroll,param);
    };
    MiddlewareWapper.prototype.getPasswordInfo=function(param){
        return toPromiseWithObj(this.obj,this.obj.getPasswordInfo,param);
    };

    MiddlewareWapper.prototype.close=function(){
        return this.obj.close()
    };

    $mx.createMiddleware=function (param) {
        return new Promise(function (resolve, reject) {
            if(!param){
                param={}
            }
            param.success=function (obj) {
                resolve(new MiddlewareWapper(obj));
            };
            param.fail=function (e) {
                reject(e)
            };
            new HebcaMiddleware.Middleware(param)
        });
    };

    function SealWrapper(obj){
        this.obj=obj;
    }
    SealWrapper.prototype.setContext=function(param){
        return toPromiseWithObj(this.obj,this.obj.setContext,param);
    };
    SealWrapper.prototype.listSeal=function(param){
        return toPromiseWithObj(this.obj,this.obj.listSeal,param);
    };
    SealWrapper.prototype.getSealInfo=function(param){
        return toPromiseWithObj(this.obj,this.obj.getSealInfo,param);
    };
    SealWrapper.prototype.getSealB64=function(param){
        return toPromiseWithObj(this.obj,this.obj.getSealB64,param);
    };
    SealWrapper.prototype.selectSeal=function(param){
        return toPromiseWithObj(this.obj,this.obj.selectSeal,param);
    };
    SealWrapper.prototype.signSealSignature=function(param){
        return toPromiseWithObj(this.obj,this.obj.signSealSignature,param);
    };
    SealWrapper.prototype.signSealSignatureBatch=function(param){
        return toPromiseWithObj(this.obj,this.obj.signSealSignatureBatch,param);
    };
    SealWrapper.prototype.verifySealSignature=function(param){
        return toPromiseWithObj(this.obj,this.obj.verifySealSignature,param);
    };
    SealWrapper.prototype.verifySealSignatureBatch=function(param){
        return toPromiseWithObj(this.obj,this.obj.verifySealSignatureBatch,param);
    };
    SealWrapper.prototype.getSealSignatureInfo=function(param){
        return toPromiseWithObj(this.obj,this.obj.getSealSignatureInfo,param);
    };
    SealWrapper.prototype.signSeal=function(param){
        return toPromiseWithObj(this.obj,this.obj.signSeal,param);
    };
    SealWrapper.prototype.signSealBatch=function(param){
        return toPromiseWithObj(this.obj,this.obj.signSealBatch,param);
    };
    SealWrapper.prototype.verifySignSeal=function(param){
        return toPromiseWithObj(this.obj,this.obj.verifySignSeal,param);
    };
    SealWrapper.prototype.verifySignSealBatch=function(param){
        return toPromiseWithObj(this.obj,this.obj.verifySignSealBatch,param);
    };
    SealWrapper.prototype.showSeal=function(param){
        return toPromiseWithObj(this.obj,this.obj.showSeal,param);
    };
    SealWrapper.prototype.loginSeal=function(param){
        return toPromiseWithObj(this.obj,this.obj.loginSeal,param);
    };
    SealWrapper.prototype.writeSeals=function(param){
        return toPromiseWithObj(this.obj,this.obj.writeSeals,param);
    };
    SealWrapper.prototype.deleteSeals=function(param){
        return toPromiseWithObj(this.obj,this.obj.deleteSeals,param);
    };
    SealWrapper.prototype.verifyCert=function(param){
        return toPromiseWithObj(this.obj,this.obj.verifyCert,param);
    };
    SealWrapper.prototype.verifySeal=function(param){
        return toPromiseWithObj(this.obj,this.obj.verifySeal,param);
    };
    SealWrapper.prototype.signSealHash=function(param){
        return toPromiseWithObj(this.obj,this.obj.signSealHash,param);
    };
    SealWrapper.prototype.oesGetSealImageById=function(param){
        return toPromiseWithObj(this.obj,this.obj.oesGetSealImageById,param);
    };
    SealWrapper.prototype.oesGetProviderInfo=function(param){
        return toPromiseWithObj(this.obj,this.obj.oesGetProviderInfo,param);
    };
    SealWrapper.prototype.selectSealHash=function(param){
        return toPromiseWithObj(this.obj,this.obj.selectSealHash,param);
    };
    SealWrapper.prototype.getPluginInfo=function(param){
        return toPromiseWithObj(this.obj,this.obj.getPluginInfo,param);
    };
    SealWrapper.prototype.handSign=function(param){
        return toPromiseWithObj(this.obj,this.obj.handSign,param);
    };
    SealWrapper.prototype.close=function(){
        return this.obj.close()
    };

    $mx.createSeal=function (param) {
        return new Promise(function (resolve, reject) {
            if(!param){
                param={}
            }
            param.success=function (obj) {
                resolve(new SealWrapper(obj));
            };
            param.fail=function (e) {
                reject(e)
            };
            new HebcaMiddleware.Seal(param)
        });
    };

    function FileSealWrapper(obj){
        this.obj=obj;
    }
    FileSealWrapper.prototype.signOfd=function(param){
        return toPromiseWithObj(this.obj,this.obj.signOfd,param);
    };
    FileSealWrapper.prototype.hashOfd=function(param){
        return toPromiseWithObj(this.obj,this.obj.hashOfd,param);
    };
    FileSealWrapper.prototype.hashOfdNext=function(param){
        return toPromiseWithObj(this.obj,this.obj.hashOfdNext,param);
    };
    FileSealWrapper.prototype.mergeOfd=function(param){
        return toPromiseWithObj(this.obj,this.obj.mergeOfd,param);
    };
    FileSealWrapper.prototype.verifyOfd=function(param){
        return toPromiseWithObj(this.obj,this.obj.verifyOfd,param);
    };
    FileSealWrapper.prototype.signPdf=function(param){
        return toPromiseWithObj(this.obj,this.obj.signPdf,param);
    };
    FileSealWrapper.prototype.hashPdf=function(param){
        return toPromiseWithObj(this.obj,this.obj.hashPdf,param);
    };
    FileSealWrapper.prototype.hashPdfNext=function(param){
        return toPromiseWithObj(this.obj,this.obj.hashPdfNext,param);
    };
    FileSealWrapper.prototype.mergePdf=function(param){
        return toPromiseWithObj(this.obj,this.obj.mergePdf,param);
    };
    FileSealWrapper.prototype.verifyPdf=function(param){
        return toPromiseWithObj(this.obj,this.obj.verifyPdf,param);
    };
    FileSealWrapper.prototype.ofd2pdf=function(param){
        return toPromiseWithObj(this.obj,this.obj.ofd2pdf,param);
    };
    FileSealWrapper.prototype.pdf2ofd=function(param){
        return toPromiseWithObj(this.obj,this.obj.pdf2ofd,param);
    };
    FileSealWrapper.prototype.openOfd=function(param){
        return toPromiseWithObj(this.obj,this.obj.openOfd,param);
    };
    FileSealWrapper.prototype.closeOfd=function(param){
        return toPromiseWithObj(this.obj,this.obj.closeOfd,param);
    };
    FileSealWrapper.prototype.getOfdInfo=function(param){
        return toPromiseWithObj(this.obj,this.obj.getOfdInfo,param);
    };
    FileSealWrapper.prototype.saveOfd=function(param){
        return toPromiseWithObj(this.obj,this.obj.saveOfd,param);
    };
    FileSealWrapper.prototype.ofdRenderPage=function(param){
        return toPromiseWithObj(this.obj,this.obj.ofdRenderPage,param);
    };
    FileSealWrapper.prototype.getOfdPageInfo=function(param){
        return toPromiseWithObj(this.obj,this.obj.getOfdPageInfo,param);
    };

    FileSealWrapper.prototype.close=function(){
        return this.obj.close()
    };

    $mx.createFileSeal=function (param) {
        return new Promise(function (resolve, reject) {
            if(!param){
                param={}
            }
            param.success=function (obj) {
                resolve(new FileSealWrapper(obj));
            };
            param.fail=function (e) {
                reject(e)
            };
            new HebcaMiddleware.FileSeal(param)
        });
    };

    function MonitorWrapper(obj){
        this.obj=obj;
    }
    MonitorWrapper.prototype.getVersion=function(param){
        return toPromiseWithObj(this.obj,this.obj.getVersion,param);
    };
    MonitorWrapper.prototype.getServiceStatus=function(param){
        return toPromiseWithObj(this.obj,this.obj.getServiceStatus,param);
    };
    MonitorWrapper.prototype.setService=function(param){
        return toPromiseWithObj(this.obj,this.obj.setService,param);
    };
    MonitorWrapper.prototype.checkDigest=function(param){
        return toPromiseWithObj(this.obj,this.obj.checkDigest,param);
    };
    MonitorWrapper.prototype.updateMoudle=function(param){
        return toPromiseWithObj(this.obj,this.obj.updateMoudle,param);
    };
    MonitorWrapper.prototype.checkVersion=function(param){
        return toPromiseWithObj(this.obj,this.obj.checkVersion,param);
    };
    MonitorWrapper.prototype.update=function(param){
        return toPromiseWithObj(this.obj,this.obj.update,param);
    };
    MonitorWrapper.prototype.checkCom=function(param){
        return toPromiseWithObj(this.obj,this.obj.checkCom,param);
    };
    MonitorWrapper.prototype.checkMoudle=function(param){
        return toPromiseWithObj(this.obj,this.obj.checkMoudle,param);
    };
    MonitorWrapper.prototype.repairMoudle=function(param){
        return toPromiseWithObj(this.obj,this.obj.repairMoudle,param);
    };
    MonitorWrapper.prototype.restartMonitor=function(param){
        return toPromiseWithObj(this.obj,this.obj.restartMonitor,param);
    };
    MonitorWrapper.prototype.setValue=function(param){
        return toPromiseWithObj(this.obj,this.obj.setValue,param);
    };
    MonitorWrapper.prototype.getValue=function(param){
        return toPromiseWithObj(this.obj,this.obj.getValue,param);
    };
    MonitorWrapper.prototype.config=function(param){
        return toPromiseWithObj(this.obj,this.obj.config,param);
    };
    MonitorWrapper.prototype.openBrowser=function(param){
        return toPromiseWithObj(this.obj,this.obj.openBrowser,param);
    };
    MonitorWrapper.prototype.showNotification=function(param){
        return toPromiseWithObj(this.obj,this.obj.showNotification,param);
    };
    MonitorWrapper.prototype.openAssistor=function(param){
        return toPromiseWithObj(this.obj,this.obj.openAssistor,param);
    };
    MonitorWrapper.prototype.close=function(){
        return this.obj.close()
    };
    MonitorWrapper.prototype.getCertHistory=function(param){
        return toPromiseWithObj(this.obj,this.obj.getCertHistory,param);
    };
    MonitorWrapper.prototype.removeCertHistory=function(param){
        return toPromiseWithObj(this.obj,this.obj.removeCertHistory,param);
    };
    MonitorWrapper.prototype.getPage=function(param){
        return toPromiseWithObj(this.obj,this.obj.getPage,param);
    };
    MonitorWrapper.prototype.setPage=function(param){
        return toPromiseWithObj(this.obj,this.obj.setPage,param);
    };
    MonitorWrapper.prototype.p11Call=function(param){
        return toPromiseWithObj(this.obj,this.obj.p11Call,param);
    };
    MonitorWrapper.prototype.findProcess=function(param){
        return toPromiseWithObj(this.obj,this.obj.findProcess,param);
    };
    MonitorWrapper.prototype.openProcess=function(param){
        return toPromiseWithObj(this.obj,this.obj.openProcess,param);
    };
    MonitorWrapper.prototype.getFilePath=function(param){
        return toPromiseWithObj(this.obj,this.obj.getFilePath,param);
    };
    MonitorWrapper.prototype.requireMoudle=function(param){
        return toPromiseWithObj(this.obj,this.obj.requireMoudle,param);
    };

    $mx.createMonitor=function (param) {
        return new Promise(function (resolve, reject) {
            if(!param){
                param={}
            }
            param.success=function (obj) {
                resolve(new MonitorWrapper(obj));
            };
            param.fail=function (e) {
                reject(e)
            };
            new HebcaMiddleware.Monitor(param)
        });
    };

    function ZXQ3Wrapper(obj){
        this.obj=obj;
    }
    ZXQ3Wrapper.prototype.pdfSign=function(param){
        return toPromiseWithObj(this.obj,this.obj.pdfSign,param);
    };
    ZXQ3Wrapper.prototype.openUrl=function(param){
        return toPromiseWithObj(this.obj,this.obj.openUrl,param);
    };
    ZXQ3Wrapper.prototype.webSign=function(param){
        return toPromiseWithObj(this.obj,this.obj.webSign,param);
    };
    ZXQ3Wrapper.prototype.startScreenShare=function(param){
        return toPromiseWithObj(this.obj,this.obj.startScreenShare,param);
    };
    ZXQ3Wrapper.prototype.stopScreenShare=function(param){
        return toPromiseWithObj(this.obj,this.obj.stopScreenShare,param);
    };
    ZXQ3Wrapper.prototype.showUser=function(param){
        return toPromiseWithObj(this.obj,this.obj.showUser,param);
    };
    ZXQ3Wrapper.prototype.getSignImage=function(param){
        return toPromiseWithObj(this.obj,this.obj.getSignImage,param);
    };
    ZXQ3Wrapper.prototype.readIDCard=function(param){
        return toPromiseWithObj(this.obj,this.obj.readIDCard,param);
    };
    ZXQ3Wrapper.prototype.compareManAndIDCard=function(param){
        return toPromiseWithObj(this.obj,this.obj.compareManAndIDCard,param);
    };
    ZXQ3Wrapper.prototype.takePicture=function(param){
        return toPromiseWithObj(this.obj,this.obj.takePicture,param);
    };
    ZXQ3Wrapper.prototype.recordSound=function(param){
        return toPromiseWithObj(this.obj,this.obj.recordSound,param);
    };
    ZXQ3Wrapper.prototype.sendData=function(param){
        return toPromiseWithObj(this.obj,this.obj.sendData,param);
    };
    ZXQ3Wrapper.prototype.multiPdfSign=function(param){
        return toPromiseWithObj(this.obj,this.obj.multiPdfSign,param);
    };
    ZXQ3Wrapper.prototype.getGrade=function(param){
        return toPromiseWithObj(this.obj,this.obj.getGrade,param);
    };
    ZXQ3Wrapper.prototype.updateGradeInfo=function(param){
        return toPromiseWithObj(this.obj,this.obj.updateGradeInfo,param);
    };
    ZXQ3Wrapper.prototype.getDeviceInfo=function(param){
        return toPromiseWithObj(this.obj,this.obj.getDeviceInfo,param);
    };
    ZXQ3Wrapper.prototype.close=function(){
        return this.obj.close()
    };

    $mx.createZXQ3=function (param) {
        return new Promise(function (resolve, reject) {
            if(!param){
                param={}
            }
            param.success=function (obj) {
                resolve(new ZXQ3Wrapper(obj));
            };
            param.fail=function (e) {
                reject(e)
            };
            new HebcaMiddleware.ZXQ3(param)
        });
    };

    function PdfWrapper(obj){
        this.obj=obj;
    }

    PdfWrapper.prototype.openPdf=function(param){
        return toPromiseWithObj(this.obj,this.obj.openPdf,param);
    };
    PdfWrapper.prototype.closePdf=function(param){
        return toPromiseWithObj(this.obj,this.obj.closePdf,param);
    };
    PdfWrapper.prototype.getPdfInfo=function(param){
        return toPromiseWithObj(this.obj,this.obj.getPdfInfo,param);
    };
    PdfWrapper.prototype.getPdfPageInfo=function(param){
        return toPromiseWithObj(this.obj,this.obj.getPdfPageInfo,param);
    };
    PdfWrapper.prototype.savePdf=function(param){
        return toPromiseWithObj(this.obj,this.obj.savePdf,param);
    };
    PdfWrapper.prototype.pdfRenderPage=function(param){
        return toPromiseWithObj(this.obj,this.obj.pdfRenderPage,param);
    };
    PdfWrapper.prototype.getPdfOutlines=function(param){
        return toPromiseWithObj(this.obj,this.obj.getPdfOutlines,param);
    };

    $mx.createPdf=function (param) {
        return new Promise(function (resolve, reject) {
            if(!param){
                param={}
            }
            param.success=function (obj) {
                resolve(new PdfWrapper(obj));
            };
            param.fail=function (e) {
                reject(e)
            };
            new HebcaMiddleware.Pdf(param)
        });
    };

    function ReaderWrapper(obj){
        this.obj=obj;
    }
    ReaderWrapper.prototype.openReader=function(param){
        return toPromiseWithObj(this.obj,this.obj.openReader,param);
    };
    ReaderWrapper.prototype.closeReader=function(param){
        return toPromiseWithObj(this.obj,this.obj.closeReader,param);
    };
    ReaderWrapper.prototype.openFile=function(param){
        return toPromiseWithObj(this.obj,this.obj.openFile,param);
    };
    ReaderWrapper.prototype.closeFile=function(param){
        return toPromiseWithObj(this.obj,this.obj.closeFile,param);
    };
    ReaderWrapper.prototype.getCurrentFileInfo=function(param){
        return toPromiseWithObj(this.obj,this.obj.getCurrentFileInfo,param);
    };
    ReaderWrapper.prototype.gotoPage=function(param){
        return toPromiseWithObj(this.obj,this.obj.gotoPage,param);
    };
    ReaderWrapper.prototype.getPage=function(param){
        return toPromiseWithObj(this.obj,this.obj.getPage,param);
    };
    ReaderWrapper.prototype.setToolBar=function(param){
        return toPromiseWithObj(this.obj,this.obj.setToolBar,param);
    };
    ReaderWrapper.prototype.setSignButtons=function(param){
        return toPromiseWithObj(this.obj,this.obj.setSignButtons,param);
    };
    ReaderWrapper.prototype.setRatio=function(param){
        return toPromiseWithObj(this.obj,this.obj.setRatio,param);
    };
    ReaderWrapper.prototype.setTitleBar=function(param){
        return toPromiseWithObj(this.obj,this.obj.setTitleBar,param);
    };
    ReaderWrapper.prototype.setLeftBar=function(param){
        return toPromiseWithObj(this.obj,this.obj.setLeftBar,param);
    };
    ReaderWrapper.prototype.setMainWindow=function(param){
        return toPromiseWithObj(this.obj,this.obj.setMainWindow,param);
    };
    ReaderWrapper.prototype.triggerAction=function(param){
        return toPromiseWithObj(this.obj,this.obj.triggerAction,param);
    };
    ReaderWrapper.prototype.addEventListener=function(param){
        return this.obj.addEventListener(param);
    };
    ReaderWrapper.prototype.removeEventListener=function(param){
        return this.obj.removeEventListener(param);
    };

    $mx.createReader=function (param) {
        return new Promise(function (resolve, reject) {
            if(!param){
                param={}
            }
            param.success=function (obj) {
                resolve(new ReaderWrapper(obj));
            };
            param.fail=function (e) {
                reject(e)
            };
            new HebcaMiddleware.Reader(param)
        });
    };

})(HebcaMiddlewareX);
